import { render, staticRenderFns } from "./RecipeIngredients.vue?vue&type=template&id=3dba8982&"
import script from "./RecipeIngredients.vue?vue&type=script&lang=js&"
export * from "./RecipeIngredients.vue?vue&type=script&lang=js&"
import style0 from "./RecipeIngredients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports